import { Modal } from "components/modal/modal";
import { NpsRatingForm } from "../nps-rating-form/nps-rating-form";
import { NpsParentForm } from "../nps-parent-form/nps-parent-form";
import { NpsThankyouAndSkipConfirmation } from "../nps-thankyou-and-skip-confirmation/nps-thankyou-and-skip-confirmation";
import { useNpsModal } from "./useNpsModal";
import { NpsFeedbackExplanationForm } from "../nps-feedback-explanation-form/nps-feedback-explanation-form";
import { IFeedbackTrialClassDataObject } from "components/kelas-live/hooks/use-user-landing/use-user-landing.types";
import { NpsThankyouAndSkipConfirmationScreenVariants } from "../nps-thankyou-and-skip-confirmation/nps-thankyou-and-skip-confirmation.types";
import { NPSModalPhases } from "./nps-modal.types";

const NPSModal = ({
  isOpen,
  onClose,
  feedbackTrialClassDataObject
}: {
  isOpen: boolean;
  onClose: () => void;
  feedbackTrialClassDataObject: IFeedbackTrialClassDataObject;
}): JSX.Element => {
  const {
    handleModalClose,
    state,
    submitParentNumberForm,
    submitNpsFeedback,
    submitFeedbackExplanationForm,
    toggleSkipConfirmation,
    trackScaleChange,
    closeFeedbackExplanationForm,
    closeSkipConfirmation,
    closeModalAfterSuccess,
    closeNpsFeedback,
    getCurrentModalPhase,
    getCurrentModalSize,
    checkParentNumberIsAlreadySubmitted
  } = useNpsModal({ onClose, feedbackTrialClassDataObject });

  return (
    <Modal
      closeOnClickOutside={false}
      size={getCurrentModalSize(state)}
      isOpen={isOpen}
      onClose={handleModalClose}
      closeIconProperties={{ isHidden: true }}>
      {/* Rating Phase */}
      {getCurrentModalPhase(state) === NPSModalPhases.RATING_PHASE && (
        <NpsRatingForm
          onClose={closeNpsFeedback}
          submitNpsFeedback={submitNpsFeedback}
          handleScaleChange={trackScaleChange}
        />
      )}
      {/* Flow A (<7) */}
      {/* Feedback Form  */}
      {getCurrentModalPhase(state) === NPSModalPhases.FEEDBACK_PHASE && (
        <NpsFeedbackExplanationForm
          handleModalClose={closeFeedbackExplanationForm}
          submitFeedbackExplanationForm={submitFeedbackExplanationForm}
        />
      )}
      {/* Thank you (Feedback) */}
      {getCurrentModalPhase(state) ===
        NPSModalPhases.THANKYOU_AFTER_FEEDBACK_FORM && (
        <NpsThankyouAndSkipConfirmation
          variant={NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_FEEDBACK}
          handleModalClose={closeModalAfterSuccess}
          toggleSkipConfirmation={toggleSkipConfirmation}
        />
      )}
      {/* Flow B (>7) */}
      {/* Parent Number Form */}
      {getCurrentModalPhase(state) ===
        NPSModalPhases.PARENT_NUMBER_INPUT_PHASE && (
        <NpsParentForm
          submitParentNumberForm={submitParentNumberForm}
          toggleSkipConfirmation={toggleSkipConfirmation}
          checkParentNumberIsAlreadySubmitted={
            checkParentNumberIsAlreadySubmitted
          }
        />
      )}
      {/* skip confirmation */}
      {getCurrentModalPhase(state) ===
        NPSModalPhases.SKIP_CONFIRMATION_PHASE && (
        <NpsThankyouAndSkipConfirmation
          variant={
            NpsThankyouAndSkipConfirmationScreenVariants.SKIP_CONFIRMATION
          }
          handleModalClose={closeSkipConfirmation}
          toggleSkipConfirmation={toggleSkipConfirmation}
        />
      )}
      {/* Thank you (Parent Number) */}
      {getCurrentModalPhase(state) ===
        NPSModalPhases.THANKYOU_AFTER_PARENT_FORM && (
        <NpsThankyouAndSkipConfirmation
          variant={
            NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_PHONE_NUMBER
          }
          handleModalClose={closeModalAfterSuccess}
          toggleSkipConfirmation={toggleSkipConfirmation}
        />
      )}
    </Modal>
  );
};

export { NPSModal };
